import type { IScene } from '@seddi/scene';
import { FidelityStates } from '@seddi/scene';

/**
 * Checks if scene has a valid garment geometry surface.
 * @param scene - the scene data.
 */
export const hasGeometrySurface = (scene: IScene): boolean => {
  const { fidelityState } = scene;
  // TODO: fidelity state progress when required
  const hasGeometry =
    fidelityState.state === FidelityStates.DigitalTwin ||
    fidelityState.state === FidelityStates.TrueSeams;
  return hasGeometry;
};
